<div class="super-container">
  <div class="container">
    <app-template-password
      [title]="title"
      [desc]="desc"
      [showExistingPassword]="true"
      [showSaveButton]="true"
      [showCancelButton]="true"
      (save)="handleSave($event)"
      (cancel)="handleCancel()"
    ></app-template-password>
  </div>
</div>
